<app-navbar appHideBreadcrumb>
    <h2>Aplicatii pentru {{job['jobTitle']}}</h2>
</app-navbar>


<div class="container" *ngIf="jobAppLoaded">
    <div class="view-applications-container">
        <div class="view-application-inner">
            <div class="tab">
                <button [ngClass]="{'active': showAllApps}" class="tablinks" (click)="displayApps('all')">Toate
                    aplicatiile ({{applications.length}})
                </button>
                <button [ngClass]="{'active': showAllInterviews}" class="tablinks" (click)="displayApps('interviews')">
                    Interviuri ({{interviews.length}})
                </button>
            </div>
            <div class="col-lg-12 pt-5">
                <div class="row">
                        <div class="w-100" id="collapseSearch">
                            <div class="card card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Sorteaza dupa camp</label>
                                            <select class="form-control form-control-md" [(ngModel)]="fieldType" name="fieldType" (change)="onSorting()">
                                                <option [selected] value="userFirstName">{{'LOGIN.FIRST_NAME' | translate}}</option>
                                                <option value="userLastName">{{'LOGIN.LAST_NAME' | translate}}</option>
                                                <option value="candidateScore">Scor candidat</option>
                                                <option value="postingDate">Data aplicarii</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Ordine</label>
                                            <select class="form-control form-control-md" [(ngModel)]="dir" name="dir" (change)="onSorting()">
                                                <option [selected] value="asc">Crescator</option>
                                                <option value="desc">Descrescator</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
            <div class="all-applications-list" *ngIf="showAllApps">
                <div class="row" *ngIf="applications.length != 0">
                    <div class="col-4 mb-5 all-aplications-list">
                        <div>
                            <div class="select-tab">
                                <div *ngIf="showAllApps" class="view-all-applications">
                                    <div class="view-application-single"
                                         *ngFor="let app of applications; let i = index">
                                        <a (click)="setCurrentApplication(i)">
                                            <div class="bg-white p-5">
                                                <div class="row align-items-center">
                                                    <div class="col-md-4 col-12 text-center">
                                                        <img src="assets/img/user-placeholder.png"
                                                        
                                                        class="img-fluid candidate-image"
                                                             alt="Candidate">
                                                    </div>
                                                    <div class="col-md-8 text-md-left col-12 text-center">
                                                        <h5 class="custom-section-title">{{app.userFirstName + " " + app.userLastName}}</h5>
                                                        <ul class="list-unstyled">
                                                            <li class="d-inline-block mr-2 blue-color">
                                                                <i class="icofont-calendar green-color mr-2"></i>{{app.applicationDetail.postingDate | date:"dd-MM-yyyy"}}
                                                                <span class="d-block"><i class="icofont-calendar green-color mr-2"></i>Aplicat la data de {{app.applicationDetail.postingDate | date:"dd-MM-yyyy"}}</span>
                                                                <!-- <span class="d-block"><i class="icofont-bars green-color mr-2"></i>Scor: {{app.candidateScore}} / 100</span> -->
                                                                <span class="d-block"><i class="icofont-archive green-color mr-2"></i>Status: {{app.statusApplication.responseStatus | enumTransform}}</span>
                                                                <!-- <span class="d-block" *ngIf="!app.containsMandatoryFields"><i class="icofont-ban green-color mr-2"></i>Acest candidat nu este eligibil</span> -->
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <div class="col-8 mb-5">
                        <div class="single-application-details">
                            <h4 class="custom-section-title candidate-name pb-10">Sumar aplicatie {{previewApplication.userFirstName + " " + previewApplication.userLastName}}</h4>
                            <h5>Raspunsuri mini-interviu</h5>
                            <div class="pb-4" *ngIf="previewApplication.miniInterviewAnswers.question1 !== ''">
                                <p><strong>1. {{previewApplication.miniInterviewAnswers.question1}}</strong></p>
                                <p>{{previewApplication.miniInterviewAnswers.answer1}}</p>
                            </div>
                            <div class="pb-4" *ngIf="previewApplication.miniInterviewAnswers.question2 !== ''">
                                <p><strong>2. {{previewApplication.miniInterviewAnswers.question2}}</strong></p>
                                <p>{{previewApplication.miniInterviewAnswers.answer2}}</p>
                            </div>
                            <div class="pb-4" *ngIf="previewApplication.miniInterviewAnswers.question3 !== ''">
                                <p><strong>3. {{previewApplication.miniInterviewAnswers.question3}}</strong></p>
                                <p>{{previewApplication.miniInterviewAnswers.answer3}}</p>
                            </div>
                            <div class="pb-4" *ngIf="previewApplication.miniInterviewAnswers.question4 !== ''">
                                <p><strong>4. {{previewApplication.miniInterviewAnswers.question4}}</strong></p>
                                <p>{{previewApplication.miniInterviewAnswers.answer4}}</p>
                            </div>
                            <div class="pb-4" *ngIf="previewApplication.miniInterviewAnswers.question5 !== ''">
                                <p><strong>5. {{previewApplication.miniInterviewAnswers.question5}}</strong></p>
                                <p>{{previewApplication.miniInterviewAnswers.answer5}}</p>
                            </div>

                            <h5>Sumar profil candidatura</h5>
                            <div class="pb-4">
                                <p><strong>Nivel cariera</strong></p>
                                <p>{{userData.currentExperienceLevel | enumTransform}}</p>
                            </div>
                            <div class="pb-4">
                                <p><strong>Locatie</strong></p>
                                <p>{{userData.city}}, {{userData.userCountry}}</p>
                            </div>
                            <div class="pb-4" >
                                <p><strong>Mobilitate geografica</strong></p>
                                <p>  Regiune de
                                    interes:  {{userData.regionOfInterest | enumTransform}} </p>
                                <p>  Disponibilitate de
                                        relocare: {{userData.availabilityOfRelocation | enumTransform}} </p>
                                <p>  Permis de conducere:    {{userData.driverLicense}} </p>
                                <p>  Disponibilitate de
                                    deplasare: {{userData.userAvailableForTraveling | enumTransform}} </p>
                                <p> Permis de munca in
                                        UE: {{userData.workPermissionInEu | enumTransform}} </p>
                            </div>
                            <div class="pb-4">
                                <p><strong>Domeniu</strong></p>
                                <p>{{userData.userActivitySector | enumTransform}}</p>
                            </div>
                            <div class="pb-4">
                                <p><strong>Experienta</strong></p>
                                <div *ngFor="let experience of userData.userExperience; let i=index">
                                <p><span>{{i+1}}. </span>Pozitie: {{experience.positionHeld}} </p>
                                <p>Companie: {{experience.employer}}</p>
                                <p>Perioada: {{experience.jobStartDate}} - {{experience.jobEndDate}}</p>
                                <p>Descriere: {{experience.mainResponsibility}}</p>
                                </div>
                                
                            </div>
                            <div class="pb-4" *ngFor="let education of userData.allUserStudies">
                                <p><strong>Nivel educatie</strong></p>
                                <div [ngSwitch]="education.userStudies">
                                    <p *ngSwitchCase="'faculty'">Facultate</p>
                                    <p *ngSwitchCase="'high_school'">Liceu</p>
                                    <p *ngSwitchCase="'college'">Colegiu</p>
                                    <p *ngSwitchCase="'master'">Master</p>
                                    <p *ngSwitchCase="'MBA'">MBA</p>
                                    <p *ngSwitchCase="'doctorate'">Doctorat</p>
                                </div>
                                
                            </div>
                            <div class="pb-4">
                                <p><strong>Limbi straine</strong></p>
                                <div *ngFor="let item of userData.foreignLanguage | keyvalue">
                                    <p>{{item.value.language}} - {{item.value.level}}</p>
                                </div>
                                
                            </div>
                            <div class="pb-4">
                                <p><strong>Gen</strong></p>
                                <p *ngIf="userData.gender == 'male'">Barbat</p>
                                <p *ngIf="userData.gender == 'female'">Femeie</p>
                            </div>
                            <div class="pb-4">
                                <p><strong>Salariu dorit</strong></p>
                                <p>{{userData.minimumSalary}} euro/luna</p>
                            </div>
                            <div class="pb-4">
                                <p><strong>Disponibilitate angajare</strong></p>
                                <p>{{userData.availableForWork | enumTransform}}</p>
                            </div>
                            <div class="view-more text-right">
                                <a routerLink="/aplicatie/{{previewApplication.id}}">
                                    <button class="c-btn view-button">Vezi aplicatia</button>
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="applications.length == 0">
                    <div class="no-applications-found">
                        <p>Momentan nu sunt aplicatii la acest job.</p>
                    </div>
                </div>
            </div>
            <div *ngIf="showAllInterviews" class="view-all-interviews">
                <div class="no-applications-found" *ngIf="interviews.length == 0">
                    <p>Momentan nu ai interviuri stabilitie.</p>
                </div>
                <div class="view-application-single" *ngFor="let app of interviews">
                    <div class="bg-white p-10">
                        <div class="row align-items-center">
                            <div class="col-md-1 col-12 text-center">
                                <img src="{{this.app.applicationDetail.logo}}" class="img-fluid" alt="Job" *ngIf="this.app.applicationDetail.logo !== 'string' &&  this.app.applicationDetail.logo !==  ''; else placeholderImage">
                                <ng-template #placeholderImage>
                                    <!--editeaza calea imaginii-->
                                    <img  src="/assets/img/placeholder.png" class="img-fluid" alt="Job">
                                </ng-template>

                            </div>
                            <div class="col-md-5 text-md-left col-12 text-center">
                                <h5 class="custom-section-title">{{previewApplication.userFirstName + " " + previewApplication.userLastName}}</h5>
                                <ul class="list-unstyled">
                                    <li class="d-inline-block mr-2 blue-color">
                                        <i class="icofont-location-pin green-color mr-2"></i>{{app.candidateAddress}}
                                    </li>
                                </ul>
                                <ul class="list-unstyled" *ngIf="app.candidateExperienceLevel !== null">
                                    <li class="d-inline-block mr-2 blue-color">
                                        <i class="icofont-worker green-color mr-2"></i>{{app.candidateExperienceLevel | enumTransform}}
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-6 col-12">
                                <ul class="list-unstyled m-0 text-md-right text-center">
                                    <li class="d-inline-block mr-2 mb-md-0 mb-2 pt-5 pb-5" *ngIf="app.statusApplication.responseStatus !== 'interviewPlanned'; else showInterviewDate">
                                        <span class="app-status">In asteptare</span>
                                    </li>
                                    <ng-template #showInterviewDate>
                                        <li class="d-inline-block mr-2 mb-md-0 mb-2 pt-5 pb-5">
                                            <span class="app-interview">Interviu: {{app.statusApplication.interviewDate  | date:"dd-MM-yyyy h:mm a"}}</span>
                                        </li>
                                    </ng-template>
                                    <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                        <a routerLink="/aplicatie/{{app.id}}">
                                            <button class="c-btn view-button">Detalii</button>
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<app-footer></app-footer>
